import React, { useEffect } from 'react';

import { WIZARD_STATUS_COMPLETE } from 'platform/site-wide/wizard';

import { usePathHistory } from '../utils/tracking/PathHistoryContext';
import useSubtaskStatusMarker from '../useSubtaskStatusMarker';
import pageNames from './pageNames';
import SubTaskContainerHeader from '../SubTaskContainerHeader';
import FileClaimComponent from '../components/FileClaimComponent';
import {
  trackSubtaskStepView,
  trackFileClaimLinkClick,
  trackExternalLinkClick,
} from '../../utils/tracking/features/subtaskTracking';

const FileClaimPage = () => {
  const { addStep, getHistory } = usePathHistory();
  useSubtaskStatusMarker(WIZARD_STATUS_COMPLETE);

  // ──────────────────────────────────────────────
  // STEP VIEW TRACKING
  // ──────────────────────────────────────────────
  useEffect(() => {
    trackSubtaskStepView({
      stepName: pageNames.fileClaim,
      pathHistoryContext: { addStep, getHistory },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SubTaskContainerHeader title="File your disability compensation claim" />
      <FileClaimComponent
        onFileClaimClick={() => {
          trackFileClaimLinkClick({
            linkLabel: 'File a disability claim online',
            pageName: pageNames.fileClaim,
            pathHistoryData: getHistory(),
          });
        }}
        onLearnMoreClick={() => {
          trackExternalLinkClick({
            linkLabel: 'Learn more about filing a disability claim',
            pageName: pageNames.fileClaim,
            pathHistoryData: getHistory(),
          });
        }}
      />
    </>
  );
};

export default {
  name: pageNames.fileClaim,
  component: FileClaimPage,
  back: pageNames.appeals,
  next: null,
};
